const store = {
    state: {
        /* Toolbar popup print */
        printTableResults: null,
        showMenuPrint: false,
        printSettings: null,
        printJob: null,
        pagePrintStyleObject: null
    },
    mutations: {
        /****** Toolbar popup print ******/
        SHOW_MENU_PRINT(state, show) {
            state.showMenuPrint = show === undefined ? !state.showMenuPrint : show;
        },
        SET_PRINT_RESULTS(state, results) {
            state.printTableResults = results;
        },
        SET_PRINT_SETTINGS(state, results) {
            state.printSettings = results;
        },
        SET_PAGE_PRINT_SIZE_STYLE(state) {
            const { width, height } = state.printJob?.previewConfig?.paper?._props ?? { width: 0, height: 0 };

            // set page size to width and height of printsettings.
            // unless they are 0 then set to auto
            let rule = `@page { size: ${width}mm ${height}mm; }`;
            if (width === 0 && height === 0) {
                rule = '@page { size: auto }';
            }

            if (!state.pagePrintStyleObject) {
                state.pagePrintStyleObject = document.createElement('style');
                document.head.appendChild(state.pagePrintStyleObject);
            }
            state.pagePrintStyleObject.innerHTML = rule;
        },
        SET_PRINT_JOB(state, job) {
            state.printJob = job;
            const prefFields = [
                'showCopyright',
                'showDate',
                'showDisclaimer',
                'showFreetext',
                'showLegend',
                'showLogo',
                'showNorth',
                'showScale',
                'showTitle',
                'size'
            ];
            const userSettings = job?.userSettings;
            let userPrefs = {};
            prefFields.forEach(pref => {
                userPrefs[pref] = userSettings?.[pref];
            });
            localStorage.setItem('PRINT_PREFS', JSON.stringify(userPrefs));
        },
    },
    actions: {
        async getPrintParameters({ commit, getters, dispatch, state }) {
            const params = {};
            let name = 'GetPrintParameters';
            if (state.context === 'web') {
                name = 'WebGetPrintParameters';
                const organizationId = getters.getOrganizationId;
                if (!organizationId) {
                    throw new Error('no organization found');
                }
                params.organizationId = organizationId;
            }
            const printParameters = await dispatch('useApiData', {
                name: name,
                parameters: params
            });
            commit('SET_PRINT_SETTINGS', printParameters.data);
            return printParameters.data;
        },
        async getPrintConfiguration({ state, dispatch }) {
            let name = 'GetPrintOnderdelen';
            if (state.context === 'web') {
                name = 'WebGetPrintOnderdelen';
            }
            const printParameters = await dispatch('useApiData', {
                name: name
            });

            return printParameters.data;
        },
        async getBitmaps({ getters, dispatch }, userIsAuthenticated) {
            let bitmaps = null;
            if (!userIsAuthenticated) {
                bitmaps = await dispatch('useApiData', {
                    name: 'WebGetWebThemeLogoAndNorthArrow',
                    parameters: { id: getters.getWebTheme.id }
                });
            } else {
                bitmaps = await dispatch('useApiData', {
                    name: 'GetOrganizationLogoAndNorthArrow'
                });
            }
            return bitmaps ? bitmaps.data : null;
        },
        async savePrintConfiguration({ dispatch }, data) {
            return dispatch('useApiData', { name: 'SavePrintOnderdelen', data });
        },
        async savePrintParameters({ dispatch }, data) {
            return dispatch('useApiData', { name: 'SavePrintParameters', data });
        }
    },
    getters: {
        getPrintJob: (state) => state.printJob,
        getPrintPrefs: () => {
            return JSON.parse(localStorage.getItem('PRINT_PREFS'));
        }
    }
};

export default store;
